module.exports = __webpack_public_path__ + "img/get.db9b21a1.png";